<section class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-main">
        <h3 class="footer-title">Ready to Get Started?</h3>
        <p class="footer-subtitle">
          Start reviewing your finances on your own schedule. No subscriptions, no compromises, no downloads required.
        </p>
        <div class="footer-cta">
          <a href="/app" class="btn btn-primary btn-large">
            Try Free Online
          </a>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-copy">
          <p>Keep &copy; 2026. </p>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  .footer {
    background: var(--color-text-primary);
    color: white;
    /* Padding controlled by parent Landing.svelte */
  }

  .footer-content {
    display: grid;
    gap: var(--spacing-3xl);
  }

  .footer-main {
    text-align: center;
  }

  .footer-title {
    font-size: var(--font-size-4xl);
    margin-bottom: var(--spacing-md);
    color: white;
  }

  .footer-subtitle {
    font-size: var(--font-size-xl);
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: var(--spacing-2xl);
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .footer-cta {
    display: flex;
    justify-content: center;
  }

  .footer-bottom {
    padding-top: var(--spacing-xl);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--spacing-lg);
  }

  .footer-copy p {
    color: rgba(255, 255, 255, 0.6);
    font-size: var(--font-size-sm);
    margin: 0;
    text-align: center;
  }

  @media (max-width: 768px) {
    .footer-title {
      font-size: var(--font-size-3xl);
    }

    .footer-bottom {
      flex-direction: column;
      text-align: center;
    }

    .footer-links {
      justify-content: center;
    }
  }
</style>
